import { STORE } from '@/constants'

export default {
  namespaced: true,
  state: {
    loading: false
  },
  getters: {
    [STORE.APP.LOADING] (state) {
      return state.loading
    }
  },
  mutations: {
    [STORE.APP.LOADING] (state, payload) {
      state.loading = payload
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.store.js